import { Form, Input, Modal } from 'antd'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons'
import { StatementSummary } from '../../../domain/invoicing/statement'
import { getBestCustomerEmail } from '../../../domain/customers/customer'
import { useCustomerEmailsQuery } from '../../../domain/customers/customerQueries'
import { useSendStatementMutation } from '../../../domain/invoicing/statementsQueries'
import { buildStatementReminderRequest } from './sendStatementModel'

type Props = {
  isOpen: boolean
  onClose: () => void
  statement: StatementSummary
}

const EmailCustomerStatementModal = ({ isOpen, onClose, statement }: Props) => {
  const [email, setEmail] = useState('')

  const customerEmailsQuery = useCustomerEmailsQuery(isOpen ? statement.customerId : 0)
  const sendMutation = useSendStatementMutation()

  useEffect(() => {
    if (!isOpen) {
      return
    }
    setEmail(getBestCustomerEmail(customerEmailsQuery.data ?? []) ?? '')
  }, [isOpen, customerEmailsQuery.data])

  const handleSubmit = () => {
    sendMutation.mutate(
      buildStatementReminderRequest(statement, [email.trim()]),
      { onSuccess: onClose }
    )
  }

  return <Modal
    open={isOpen}
    title="Email Customer Statement"
    okText="Email Statement"
    okButtonProps={{ loading: sendMutation.isLoading, disabled: sendMutation.isLoading || email.trim().length === 0 }}
    onOk={handleSubmit}
    onCancel={onClose}
  >
    <Form layout="vertical">
      <Form.Item label="Customer Email Address">
        <Input
          prefix={<FontAwesomeIcon icon={faEnvelope} />}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Form.Item>
    </Form>
  </Modal>
}

export default EmailCustomerStatementModal
